/** --------------------------------------------------
* 
*   THEME SCRIPT
*
*   TABLE OF CONTENTS
*   document ready
*
*  -------------------------------------------------- */

(function($) {

  "use strict";

  /** --------------------------------------------------
  *   #document ready
  *   -------------------------------------------------- */

  $(function() {

    // setup header:
    // -> mobile:
    setupMobileHeader();
    // -> eatable menu:
    new duo.EatableMenu({
      menuSelector: '.desktop-header__navigation-block',
      menuList: '.desktop-header__navigation-block__more__list'
    });

  });




  /** --------------------------------------------------
  *   #header
  *   -------------------------------------------------- */

 function setupMobileHeader() {
    // navigation modal:
    new duo.Modal({
      modalSelector: '.js-mobilenav-modal',
      toggleButtonClass: 'js-mobilenav-toggle',
      openClass: 'js-mobilenav-visible',
      classHolder: 'html',
      useTransitions: true,
      fixPagePositionWhenOpen: true,
      fixPageClass: 'js-mobilenav-fixed',
      elementToChangeScrollOnFixed: $('.site-wrapper')
    });
  }




})(jQuery);
